import { render, staticRenderFns } from "./bussinessMeal.vue?vue&type=template&id=f15e6422&scoped=true&"
import script from "./bussinessMeal.vue?vue&type=script&lang=js&"
export * from "./bussinessMeal.vue?vue&type=script&lang=js&"
import style0 from "./bussinessMeal.vue?vue&type=style&index=0&id=f15e6422&prod&lang=less&scoped=true&"
import style1 from "./bussinessMeal.vue?vue&type=style&index=1&id=f15e6422&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15e6422",
  null
  
)

export default component.exports